export interface HeaderItem {
    name: string;
    description: string;
    codeName?: string;
}

export const headerItemComparer = (a?: HeaderItem | null, b?: HeaderItem | null): boolean => {
    return a?.name === b?.name && a?.description === b?.description && a?.codeName === b?.codeName;
}